
(function (Drupal) {
  Drupal.behaviors.menuSecondary = {
    nav: priorityNav.init({mainNavWrapper: 'body:not(.section--invest, .section--meet, .section--acb) nav.navigation--secondary'}),
    attach: function (context) {
      var docBod = document.body;
      var htmlTag = document.body.parentNode;

      // Get the scrollbar width best we can and set as a CSS var.
      var scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth);

      once('menuSecondaryClick', '.navigation--secondary .dropbtn', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          var isActiveMenu = e.target.closest('.dropdown').classList.contains('active-menu');
          if (window.currentSecondaryTarget ) {
            window.currentSecondaryTarget.classList.remove('active-menu');
            docBod.style.overflowY = 'auto';
            htmlTag.classList.remove('overflow');
          }
          window.currentSecondaryTarget = this.closest('.dropdown');
          if (!isActiveMenu) {
            window.currentSecondaryTarget.classList.add('active-menu');
            docBod.style.overflowY = 'hidden';
            htmlTag.classList.add('overflow');
          }
        });
      });
      once('menuSecondaryOff', 'html', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          if (window.currentSecondaryTarget) {
            var dropdown =  e.target.closest('.dropdown');
            if (dropdown != window.currentSecondaryTarget) {
              window.currentSecondaryTarget.classList.remove('active-menu')
              window.currentSecondaryTarget = null;
            }
          }
        });
      });
    }
  }
})(Drupal);